import { push } from 'connected-react-router';
import {
  useCallback, useMemo, useState,
} from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { useDidMount } from '../../../../../../hooks/life-cycle';
import { DialogActions } from '../../../../../../redux/dialog/dialog.action';
import { State } from '../../../../../../redux/root.reducer';
import { RoutingPath } from '../../../../../../routes/routing-pass';
import { SupportHistoryListType } from '../../../../../../type/support-history/support-history.type';
import { CardList } from '../../../../../ui/card/card-list/card-list';
import { SupportHistoryCard } from '../../../../../ui/card/support-history/support-history-card';

type Props = {
  // type?: 0 | 1 | 2;
  data?: SupportHistoryListType[] | null;
  handleCardClick?:(supportHistory: SupportHistoryListType) => void;
}

export const SupportHistoryListSP = (props: Props) => {
  const { data, handleCardClick } = props;

  const { ref, inView } = useInView({
    // オプション
    rootMargin: '-50px', // ref要素が現れてから50px過ぎたら
    triggerOnce: true, // 最初の一度だけ実行
  });

  /* Hooks */
  const supportHistoryListData = data || data === null
    ? data
    : useSelector((state: State) => state.supportHistory.list);
  const dispatch = useDispatch();
  const [isInCustomerDetail, setIsInCustomerDetail] = useState(false);

  /* List */
  const supportHistoryList = useMemo(() => supportHistoryListData, [data, supportHistoryListData]);

  const handleClickCard = useCallback((id: number) => {
    if (handleCardClick) {
      const findData = data?.find((v) => v.id === id);
      if (findData) handleCardClick(findData);
      dispatch(DialogActions.pop());
      dispatch(DialogActions.pop());
      return;
    }
    dispatch(push(`${RoutingPath.supportHistoryDetail}/${id}`));
  }, [data]);

  useDidMount(() => {
    const arr = window.location.href.split('customer/detail');
    setIsInCustomerDetail(arr.length >= 2);
  });

  return (
    <CardList isLoading={inView} list={supportHistoryList}>
      {supportHistoryList?.map((v, i) => (
        <div
          key={`card${i}`}
          className="list_base_card_wrap"
          ref={supportHistoryList.length - 1 ? ref : undefined}
        >
          <SupportHistoryCard
            supportHistoryData={v}
            onClick={(id) => handleClickCard(id)}
            isInCustomerDetail={isInCustomerDetail}
          />
        </div>
      ))}
    </CardList>
  );
};
